// src/views/AttendanceMaster/StudentAttendanceReport.jsx
import React, { useEffect, useState } from 'react';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Input,
  Table,
  Row,
  Col,
} from 'reactstrap';
import { apiService } from '../../constants/ApiService';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { toast } from 'react-toastify';

const StudentAttendanceReport = () => {
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});

  const [selectionData, setSelectionData] = useState({
    vendor_id: user?.vendor_id ?? '',
    branch_id: user?.branch_id ?? '',
  });

  const [classId, setClassId] = useState('');
  const [batchId, setBatchId] = useState('');
  const [fromDate, setFromDate] = useState(
  new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    .toISOString()
    .split("T")[0]);
  const [toDate, setToDate] = useState(
  new Date().toISOString()
    .split("T")[0]);

  const [classList, setClassList] = useState([]);
  const [batchList, setBatchList] = useState([]);
  const [reportList, setReportList] = useState([]);
  

  const getClassListData = async (search = '') => {
    const vendorId = selectionData.vendor_id || '';
    const branchId = selectionData.branch_id || '';

    try {
      const response = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          search
        )}`
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setClassList(response.data || []);
      } else {
        console.error(response.message || 'Failed to fetch');
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };

  const getBatchListData = async (classIdValue, search = '') => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      if (!classIdValue) {
        setBatchList([]);
        return;
      }

      const response = await apiService.get(
        `api/BatchMaster/GetAllBatch?classId=${classIdValue}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          search || ''
        )}`
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setBatchList(response.data || []);
      } else {
        console.error(response.message || 'Failed to fetch');
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong!!');
    }
  };

  const getReportData = async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      if (!classId || Number(classId) <= 0) {
        alert('Please select Class');
        return;
      }

      if (!fromDate || !toDate) {
        alert('Please select From Date and To Date');
        return;
      }

      const response = await apiService.get(
        `api/AttendanceMaster/GetAttendanceReportByDateRange?classId=${classId}&fromDate=${fromDate}&toDate=${toDate}&batchId=${batchId}&vendorId=${vendorId}&branchId=${branchId}`
      );

      if (response.response && response.response.data?.errors) {
        toast.error(response.response.data.errors);
      }

      if (response.status === true) {
        setReportList(response.data || []);
      } else {
        console.error(response.message || 'Failed to fetch');
        alert(response.message || 'Failed to fetch');
        setReportList([]);
      }
    } catch (error) {
      console.error(error);
      toast.error('SomeThing went wrong');
    }
  };

  const onHandleClassChange = (e) => {
    const val = e.target.value;
    setClassId(val);

    setBatchId('');
    setBatchList([]);

    if (val) getBatchListData(val, '');
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      getClassListData('');

      // same reset behavior
      setReportList([]);
      setClassId('');
      setBatchId('');
      setBatchList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id]);

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-clipboard-data mr-2' /> Student Attendance Report
        </CardTitle>

        <CardBody>
          <Row className='g-2 align-items-end'>
            <Col md={3}>
              <label className='form-label'>Class</label>
              <Input
              className='custom-select'
                type='select'
                value={classId}
                onChange={onHandleClassChange}
              >
                <option value=''>-Select Class-</option>
                {(classList || []).map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.class_Name ?? x.class_display_name ?? x.name ?? ''}
                  </option>
                ))}
              </Input>
            </Col>

            <Col md={3}>
              <label className='form-label'>Batch </label>
              <Input
              className='custom-select'
                type='select'
                value={batchId}
                onChange={(e) => setBatchId(e.target.value)}
              >
                <option value=''>-All-</option>
                {(batchList || []).map((x) => (
                  <option key={x.id} value={x.id}>
                    { x.batch_code}
                  </option>
                ))}
              </Input>
            </Col>

            <Col md={2}>
              <label className='form-label'>From Date</label>
              <Input
                type='date'
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            <Col md={2}>
              <label className='form-label'>To Date</label>
              <Input
                type='date'
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>

            <Col md={2} className='text-right'>
              <Button
                color='primary'
                onClick={getReportData}
                style={{ width: '100%' }}
              >
                <i className='bi bi-search' /> Fetch
              </Button>
            </Col>
          </Row>

          <hr />

          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>StudentId</th>
                <th>Student Name</th>
                <th>Total Working Days</th>
                <th>Present Days</th>
                <th>Absent Days</th>
                <th>Attendance %</th>
              </tr>
            </thead>
            <tbody>
              {reportList.length > 0 ? (
                reportList.map((x, i) => (
                  <tr key={x.studentId ?? i}>
                    <td>{i + 1}</td>
                    <td>{x.studentId}</td>
                    <td>{x.studentName}</td>
                    <td>{x.totalWorkingDays}</td>
                    <td>{x.presentDays}</td>
                    <td>{x.absentDays}</td>
                    <td>{x.attendancePercentage}%</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='7' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default StudentAttendanceReport;
